import { useCallbackRef } from '@chakra-ui/react';
import { useEffect } from 'react';
import { debounce } from '../lodash';
export const useResize = (cb, delay = 100) => {
    const cbRef = useCallbackRef(cb);
    useEffect(() => {
        const debouncedCb = debounce(cbRef, delay, true);
        window.addEventListener('resize', debouncedCb);
        return () => {
            debouncedCb.cancel();
            window.removeEventListener('resize', debouncedCb);
        };
    }, [cbRef, delay]);
};
